import { useRef } from 'react';
import { getColorShade, getContrastColor } from '../../utils/utils';
import Backdrop from './Backdrop';

const iconPath = 'https://s3-us-west-2.amazonaws.com/pbsco-static/icons/social';

const EmailDemo = ({ template, backdrop }) => {
  if (!template) {
    return null;
  }

  const {
    backgroundColor,
    accentColor,
    logoSectionEnabled,
    sharingSectionEnabled,
    customSectionEnabled,
    footerSectionEnabled,
    logoSection: { logoImage, tagline, subtitle },
    sharingSection: {
      socialSharing: {
        facebook: { enabled: facebookEnabled },
        twitter: { enabled: twitterEnabled },
        reddit: { enabled: redditEnabled },
        pinterest: { enabled: pinterestEnabled },
        tumblr: { enabled: tumblrEnabled },
      },
    },
    customSection: { headline: customHeadline, body: customBody, callToActionButtonTitle },
    footerSection: {
      headline: footerHeadline,
      details: { email: companyEmail, website: companyWebsite, phone: companyPhone },
      socialAccounts: { facebook: companyFacebook, twitter: companyTwitter, instagram: companyInstagram },
    },
  } = template;

  const accentShade = useRef(getColorShade(accentColor, true));
  const backgroundShade = useRef(getColorShade(backgroundColor, true));
  const accentTextColor = useRef(getContrastColor(accentColor));
  const backgroundTextColor = useRef(getContrastColor(backgroundColor));
  const shareIcons = useRef(
    (() => [
      ...(facebookEnabled ? ['facebook'] : []),
      ...(twitterEnabled ? ['twitter'] : []),
      ...(redditEnabled ? ['reddit'] : []),
      ...(pinterestEnabled ? ['pinterest'] : []),
      ...(tumblrEnabled ? ['tumblr'] : []),
    ])()
  );
  const companyIcons = useRef(
    (() => [
      ...(companyFacebook ? ['facebook'] : []),
      ...(companyTwitter ? ['twitter'] : []),
      ...(companyInstagram ? ['instagram'] : []),
    ])()
  );

  return (
    <div className="iphone-demo">
      <div className="iphone-demo__phone">
        <div className="iphone-demo__screen">
          <div className="share-email" style={{ backgroundColor, color: backgroundTextColor.current }}>
            {logoSectionEnabled && (
              <div className="share-email__section">
                {logoImage && <img alt="" className="share-email__logo" src={logoImage} />}
                {tagline && <h2 className="share-email__heading">{tagline}</h2>}
                {subtitle && <p className="share-email__subheading">{subtitle}</p>}
              </div>
            )}
            <div className="share-email__photo">
              <Backdrop backdrop={backdrop} />
              <img src="/static/model/4/4.png" />
            </div>
            {sharingSectionEnabled && (
              <div className="share-email__section" style={{ paddingBottom: 0 }}>
                <h2 className="share-email__heading">Share your media</h2>
                <p className="share-email__text" style={{ marginBottom: '1em' }}>
                  Or <span style={{ color: accentColor }}>view the gallery</span>.
                </p>
                <ul className="share-email__row">
                  {shareIcons.current.map((name) => (
                    <li key={name}>
                      <img
                        className="share-email__icon"
                        src={`${iconPath}/${backgroundShade.current}/${name}.png`}
                        alt={name}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {customSectionEnabled && (
              <div className="share-email__section">
                {customHeadline && <h2 className="share-email__heading">{customHeadline}</h2>}
                {customBody && <p className="share-email__text">{customBody}</p>}
                {callToActionButtonTitle && (
                  <div className="share-email__btn" style={{ background: accentColor, color: accentTextColor.current }}>
                    {callToActionButtonTitle}
                  </div>
                )}
              </div>
            )}
            <div style={{ width: '100%', height: 150, backgroundColor }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailDemo;
